import { Button, ButtonOwnProps } from '#app/components/Buttons/Button.js';
import {
  FinanceIntegrationUpsellAnalyticsSection,
  useFinanceIntegrationUpsell,
} from '#app/hooks/useFinanceIntegrationUpsell.js';
import { useIsMobile } from '#app/hooks/useIsMobile.js';
import { AddIcon } from '@contra/icons/icons';

type AddFinanceIntegrationButtonProps = ButtonOwnProps & {
  readonly analyticsSection: FinanceIntegrationUpsellAnalyticsSection;
  readonly condenseOnMobile?: boolean;
  readonly customLabel?: string;
};

export const AddFinanceIntegrationButton = (
  props: AddFinanceIntegrationButtonProps,
) => {
  const isMobile = useIsMobile();
  const { openFinanceIntegrationUpsellModal } = useFinanceIntegrationUpsell({
    analyticsSection: props.analyticsSection,
  });

  return (
    <Button
      icon={AddIcon}
      onClick={() =>
        openFinanceIntegrationUpsellModal({
          section: props.analyticsSection,
        })
      }
      removeMinWidth
      size="xsmall"
      variant="V2TertiaryOutline"
      {...props}
    >
      {props.customLabel
        ? props.customLabel
        : isMobile && props.condenseOnMobile
          ? null
          : 'Add finance integration'}
    </Button>
  );
};
